import { FC, useEffect } from 'react';
import { CompactSlate } from './CompactSlate';
import { ListSlate } from './ListSlate';
import { IPage, IPageType } from 'store/donatePage/types';
import { CandidateType } from './Candidates/Candidates';
import { IRecipient } from 'store/recipients/types';
import { MediaSlate } from 'screens/MediaSlate';
import { clearCheckoutIdempotencyKey } from 'services/storage';
import { RecSlate } from './RecSlate';
import { OathRecurringInterval } from 'store/pay/types';

interface Props {
  page?: IPage;
  candidates: CandidateType[];
  onDonateClick: (selectedMethod?: string) => void;
  onSelectCandidates: (updatedCandidates: CandidateType[]) => void;
  handleCandidatesSelected: (index: number, checkValue: boolean) => void;
  onUserDonationTotalChange: (value?: number) => void;
  recipients: IRecipient[];
  selectedDonationAmount?: number;
  overageMax?: number;
  setCandidates: React.Dispatch<React.SetStateAction<CandidateType[]>>;
  setSelectedDonationAmount: React.Dispatch<React.SetStateAction<number | undefined>>;
  showCustomSplit: boolean;
  type: IPageType;
  onDafDonateClick: () => void;
  isDafEnabled: boolean;
  isRecurring: boolean;
  setIsRecurring: (isRecurring: boolean) => void;
  recurringInterval: OathRecurringInterval;
  isMonthlyEnabled: boolean;
  enableScrollToDonate: boolean;
}

export const Slate: FC<Props> = ({ type, enableScrollToDonate, ...slateProps }) => {
  useEffect(() => {
    clearCheckoutIdempotencyKey();
  }, []);

  if (type === 'COMPACT') {
    return <CompactSlate {...slateProps} enableScrollToDonate={enableScrollToDonate} />;
  } else if (type === 'REC') {
    return <RecSlate {...slateProps} />;
  } else if (type === 'MEDIA') {
    return <MediaSlate {...slateProps} />;
  }
  return <ListSlate {...slateProps} />;
};
